import React from "react";
import { message, Button, Table, Select, Input ,Modal} from 'antd';
import getSize from "../../../../utils/getSize";
import NHFetch from "../../../../utils/NHFetch";
import NHTable from '../../../common/NHTable';
import css from './index.css';
import NHInputRender from '../../../common/NHInputPicker/render';
import moment from 'moment';
import { hasAuth, createUuid, getLoginUser } from "../../../../utils/NHCore";
import ReactDOM from 'react-dom'

const Search = Input.Search;

export default class Xsxxcjcx extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            valiteColumns: [],
            dmkmcList:{},
            previewVisible: false,
            fjColumnName: [],
        }
    }

    componentDidMount() {
        NHFetch('/xxcj/bdgl/getValiteColumns', 'GET').then(res => {
            if (res && res.data && res.data.length > 0) {
                console.log(res.data)
                this.setState({ valiteColumns: res.data });
            } else {
                message.warning('当前未配置学生采集信息项');
            }
        }).catch((error) => {
            message.error('服务器异常！');
        });
    }

    //获取下拉列表value对应的名称
    getDmkMc = (dmbz, zdbz) => {
        NHFetch("/proData/selectDataList", "GET", { sign: dmbz })
            .then(res => {
                if (res) {
                    if (res.data) {
                        let dmkmcList = this.state.dmkmcList;
                        dmkmcList[zdbz] = res.data;
                        this.setState({
                            dmkmcList: dmkmcList
                        })
                    }
                }
            });
    }

    handleOtpBtnClick = () => {
        this.refs.nhTable.exportExcel('学生采集信息');
    }

    handleBatchExportBtnClick = () => {
        let recordRows = this.refs.nhTable.state.data;
        let { fjColumnName } = this.state;
        fjColumnName = [...new Set(fjColumnName)];
        let sfzjhList = [];
        recordRows.map(item => sfzjhList.push(item.SFZJH));
        this.downloadDetailData("/api/zhxg-yxxt/gdwyyszyxy/export/exportXsxxcjFjZip", sfzjhList, fjColumnName);
    }

    downloadDetailData = (downloadUrl, params, fjColumnName) => {
        var divElement = document.getElementById("downloadDiv");
        let loginUserId = getLoginUser().userId;
        let loginUserName = getLoginUser().userName;
        ReactDOM.render(
            <form action={downloadUrl} method="post" target="_blank">
                <input name="sfzjhList" type="text" value={params} />
                <input name="fjColumnName" type="text" value={fjColumnName} />
                <input name="loginUserId" type="text" value={loginUserId}/>
                <input name="loginUserName" type="text" value={loginUserName}/>
            </form>,
            divElement
        )
        ReactDOM.findDOMNode(divElement).querySelector('form').submit();
        ReactDOM.unmountComponentAtNode(divElement);

    }

    //获取下拉列表value对应的名称
    getDmkMc = (dmbz, zdbz) => { 
        NHFetch("/proData/selectDataList", "GET", { sign: dmbz })
            .then(res => { 
                if (res) {
                    if (res.data) {
                        let dmkmcList = this.state.dmkmcList;
                        dmkmcList[zdbz] = res.data;
                        this.setState({
                            dmkmcList: dmkmcList
                        })
                    }
                }
            });
    }
      //获取联级下拉列表value对应的名称
    getCascaderDmkMc = (level,sign, cascaderValue,zdbz) => { 
        NHFetch("/proData/selectCascaderList", "GET", { level:level,sign: sign ,cascaderValue:cascaderValue})
            .then(res => {  
                if (res) {
                    if (res.data) {
                        let dmkmcList = this.state.dmkmcList;
                        dmkmcList[level+zdbz] = res.data; 
                        this.setState({
                            dmkmcList: dmkmcList
                        })
                    }
                }
            });
    }
    // 点击文件链接或预览图标时的回调
    handlePreview = (fjmc, fjid) => { 

        if (fjmc==="isImage") {
            this.showPreview(`anonymity/docrepo/download/file?attachmentId=${fjid}`);
        } else {
            window.open(`anonymity/docrepo/download/file?attachmentId=${fjid}`);
        }
    };

    //打开图片弹窗
    showPreview = (url) => {
        this.setState({
            previewImage: url,
            previewVisible: true
        });
    }
    // 关闭图片弹窗
    closeModal = () => this.setState({ previewVisible: false });
    // 文件展示 
    fileLists = (fileLists) => {
            {
                let items=[];
                for(let key in fileLists){
                    let fileList = typeof fileLists[key] == 'string'?fileLists[key].split(";"):fileLists[key]; 
                    items.push (
                        <div >
                            <a onClick={() => {
                             this.handlePreview("file",fileList[0]);
                            }}>{fileList[1]}</a> 
                        </div>
                    )
                }
            return items;
            }
        };
    //图片展示
    imageLists = (imageLists) =>{
        {
            let items=[];
            for(let key in imageLists){
                let imageList = typeof imageLists[key] == 'string'?imageLists[key].split(";"):imageLists[key];
                items.push (
                    <span>
                       <img style={{height:"80px" ,width:"80px"}} src={"anonymity/docrepo/download/file?attachmentId=" + imageList}
                        onClick={() => {
                            this.handlePreview("isImage",imageList[0]);
                        }}/>
                    </span>
                )
            }
            return items;
        }
    }
    render() {

        const { valiteColumns,previewVisible,previewImage,fjColumnName  } = this.state;
        const columnConst = [
            {
                title: '序号',
                dataIndex: 'ROW_ID',
                width: '50px',
                fixed: 'left'
            }, {
                title: '学号',
                dataIndex: 'XH',
                width: '120px',
                fixed: 'left',
                searchType:"input"
            }, {
                title: '姓名',
                dataIndex: 'XM',
                width: '90px',
                search: 'input',
                fixed: 'left',
                searchType:"input"
            }, {
                title: '性别',
                width: '70px',
                dataIndex: 'XB',
                fixed: 'left',
                searchType:"select"
            }, {
                title: '身份证号',
                dataIndex: 'SFZJH',
                width: '160px',
                fixed: 'left',
                searchType:"input"
            }, {
                title: '校区',
                width: '200px',
                dataIndex: 'XQMC',
                searchType:"select",
                // hidden: true
            }, {
                title: '院系',
                width: '200px',
                dataIndex: 'BMMC',
                searchType:"select"
            }, {
                title: '专业',
                width: '200px',
                dataIndex: 'ZYMC',
                searchType:"select"
            }, {
                title: '班级',
                width: '200px',
                dataIndex: 'BJMC',
                searchType:"select"
            }
        ];

        let extraColumns = [];
        if (valiteColumns && valiteColumns.length > 0) {
            valiteColumns.forEach((item) => {
                const {zdmc = null,zdbz = null,kjcs} = item?item:{zdmc:null,zdbz:null}; 
                let column = {
                    title: zdmc,
                    width: parseInt(zdmc?zdmc.length:0) * 20 + 40 + 'px',
                    dataIndex: zdbz?zdbz.toUpperCase():null,
                    //key: zdbz?zdbz.toLowerCase():null,
                    render: (text, record) => {

                        let zdz = record[zdbz];
                        let kjcsjson = JSON.parse(kjcs);
                        let zdzmc = '';
                        if(kjcsjson.type === 'datepicker'||kjcsjson.type === 'datetimepicker'||kjcsjson.type === 'timepicker'||kjcsjson.type === 'monthpicker'||kjcsjson.type === 'rangepicker'){    //日期值展示阶段，从moment转为文字 
                            if(zdz){
                                zdzmc=moment(zdz).format(kjcsjson.format);
                            }
                        } else if (kjcsjson.type === "multiselect") { 
                            if (kjcsjson.dataTag && !this.state.dmkmcList[zdbz]) {
                                this.getDmkMc(kjcsjson.dataTag, zdbz);
                            }
                            let list = this.state.dmkmcList[zdbz]; 
                            if(zdz ){ 
                                let multiselect=typeof zdz == 'string'?zdz.split(","):zdz;    
                                let multiselectList=[];
                                for(let i in multiselect){
                                    list && list.map(item => {
                                        if (item.VALUE === multiselect[i]) {
                                            multiselectList.push(item.LABEL);
                                        }
                                    })
                                }
                                zdzmc=multiselectList.join(",");
                         }
                        }else if (kjcsjson.type === "nhcascader") {   
                            if(zdz){ 
                                let nhcascaderList=typeof zdz == 'string'?zdz.split(","):zdz;     
                                let nhcascaderLists=[];    
                                for(let i in nhcascaderList){  
                                    let level=i;
                                    let c=i;
                                    let d=i;
                                    let a=++level;
                                    let b=--d;
                                    if (kjcsjson.dataTag && !this.state.dmkmcList[a+zdbz] ) {
                                        if(i == "0"){
                                            this.getCascaderDmkMc(a,kjcsjson.dataTag,'',zdbz) 
                                        }
                                        else{
                                            this.getCascaderDmkMc(a, kjcsjson.dataTag,nhcascaderList[b],zdbz) 
                                        } 
                                    }
                                        let list=this.state.dmkmcList[level+++zdbz];
                                        
                                        list && list.map(item => {   
                                            if (item.value === nhcascaderList[c]) { 
                                                nhcascaderLists.push(item.label);
                                            }
                                        }) 
                                }
                                zdzmc=nhcascaderLists.join("/");
                            }
                         }else if(kjcsjson.type === "switch"){
                            zdzmc = (zdz === "1" || zdz === true) ? kjcsjson.checkedText:kjcsjson.uncheckedText;
                        } else if(kjcsjson.type === "radio"){
                            kjcsjson.options&&kjcsjson.options.map((item,key)=>{
                                if(item.value === zdz){
                                    zdzmc = item.label;
                                }
                            })
                        }else if(kjcsjson.fileType === "file" && zdz  ){  
                            let fileLists=typeof zdz == 'string'?zdz.split(","):zdz;  
                            fjColumnName.push(zdbz);
                            zdzmc=(
                                this.fileLists( fileLists)  
                            )
                        }else if(kjcsjson.fileType === "image" && zdz ){    
                            if (typeof zdz === 'object') { 
                                let array = [];
                                for (let item of zdz) {
                                    if (item.hasOwnProperty('uuid') && item['uuid']) {
                                        array.push(item['uuid']) 
                                    }
                                }
                                zdz= array
                            }else{
                                zdz=zdz.split(",");
                            } 
                            zdzmc=(
                                this.imageLists(zdz)  
                            )  
                        } 
                        // if (kjcsjson.type === "select") {
                        //     if (kjcsjson.dataTag && !this.state.dmkmcList[zdbz]) {
                        //         this.getDmkMc(kjcsjson.dataTag, zdbz);
                        //     }
                        //     let list = this.state.dmkmcList[zdbz];
                        //     list && list.map(item => {
                        //         if (item.VALUE === zdz) {
                        //             zdzmc = item.LABEL;
                        //         }
                        //     })
                        // } else
                        //     if (kjcsjson.type === "switch") {
                        //         if(zdz==='1' || zdz === true){
                        //             zdzmc = kjcsjson.checkedText;
                        //         }else if(zdz==='0' || zdz === false){
                        //             zdzmc = kjcsjson.uncheckedText;
                        //         }else{
                        //             zdzmc = "";
                        //         }
                        //     }
                        //     else if (kjcsjson.type === "radio") {
                        //         kjcsjson.options && kjcsjson.options.map((item, key) => {
                        //             if (item.value === zdz) {
                        //                 zdzmc = item.label;
                        //             }
                        //         })
                        //     }
                            else {
                                zdzmc = zdz;
                            }
                        return zdzmc;
                    },
                };
                if(column.title){
                    extraColumns.push(column);
                }
            });
        }
        let maxSearchTitle = 2;
        let searchLength = 0;
        let tyOptions = columnConst.map((item, index) => {
            if (item.commonSearch !== false && item.title != '序号' && item.title != '操作') {
                searchLength++;
                if (item.title.length > maxSearchTitle) {
                    maxSearchTitle = item.title.length;
                }
                return <Select.Option value={item.dataIndex} key={createUuid()}>{item.title}</Select.Option>
            } else {
                return '';
            }
        })

        return (
            <div className={css.main_right_content} style={{ height: getSize().windowH - 123 }}>
                {
                    extraColumns.length > 0 && extraColumns ?
                        undefined
                        :
                        <div id='homeSearchDiv' style={{ marginBottom: '16px' }}>
                            <Select
                                value="all"
                                dropdownMatchSelectWidth={false}
                                dropdownStyle={{ width: (tyOptions && searchLength > 6) ? (80 + (maxSearchTitle - 2) * 15) : 'auto' }}
                            >
                                <Select.Option value="all">全部</Select.Option>
                                {
                                    tyOptions
                                }
                            </Select>
                            <Search
                                placeholder="请输入查询条件"
                                style={{ width: 230 }}
                            />
                            <Button type="primary" style={{ margin: '0 20px' }}>查询</Button>
                            <Button type="Default" style={{ paddingLeft: 5 }} ghost icon="reload">重置</Button>
                        </div>
                }
                
                <div id='downloadDiv' style={{ display: 'none' }}></div>
                
                <div style={{ width: '100%', height: '100%', }}>
                    {extraColumns.length > 0 && extraColumns ?
                        <NHTable ref='nhTable'
                            rowKey={record => record.PKID}
                            sign={"zhxg_yxxt_tjcx_xscjxx_queryPage"}
                            columns={columnConst.concat(extraColumns)}
                            sqlParams={{xxcjSign:'zhxg_yxxt_xscjxxzd'}}
                            rangeFilter={false}
                        >
                            {hasAuth("zhxg_yxgl_tjcx_xsxxcjcx:export") ? <Button type="primary" ghost onClick={this.handleOtpBtnClick} style={{ marginLeft: 10 }}>导出</Button> : undefined}
                            {hasAuth("zhxg_yxgl_tjcx_xsxxcjcx:batchExport") ? <Button type="primary" ghost onClick={this.handleBatchExportBtnClick} style={{ marginLeft: 10 }}>批量导出附件</Button> : undefined}
                        </NHTable>
                        :
                        <Table ref='nhTableNone'
                            columns={columnConst.concat(extraColumns)}
                            size="small"
                            bordered
                        >
                        </Table>
                    }
                </div>
                <Modal
                        visible={previewVisible}
                        footer={null}
                        onCancel={this.closeModal}
                    >
                        <img
                            alt="example"
                            style={{ width: '100%' }}
                            src={previewImage}
                        />
                    </Modal>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./components/tjcx/xsxxcjcx/gwyXsxxcjcx/index.js